// voiceSnippetSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { allRoutes } from '../constants/config'
const {
  GET_API_USER_ASSET_TREE
} = { ...allRoutes }

export const getUserAssetTree = createAsyncThunk(
  'userAssets/getAssetTree', async (token) => {
    console.log('GETUSERASSETTREE ---------------- token', token)
    const response = await axios({
      method: 'get', url: GET_API_USER_ASSET_TREE,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data
  })

const userAssetsSlice = createSlice({
  name: 'userAssets',
  initialState: {
    userAssetData: {},
    userLitGroupData: {},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserAssetTree.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserAssetTree.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded"
        state.userAssetData = { ...action.payload.userAssets };
        state.userLitGroupData = { ...action.payload.litGroupsData };
        state.error = null;
      })
      .addCase(getUserAssetTree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error;
      });
  },
});

export default userAssetsSlice.reducer;

export const selectAllUserAssets = (state) => state.user.userAssets;
